import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttributeApplyNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.6953 0.812073L9.29881 18.1781L3.06331 12.0375L0.536713 14.6016L8.33671 22.2821C9.10591 23.0751 10.5225 22.9248 11.1046 21.9868L23.7047 2.78787L20.6953 0.812073Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttributeApplyNsk.displayName = 'AttributeApplyNsk';
